import { render, staticRenderFns } from "./dygpt.vue?vue&type=template&id=0ed1ff0b&scoped=true"
import script from "./dygpt.vue?vue&type=script&lang=js"
export * from "./dygpt.vue?vue&type=script&lang=js"
import style0 from "./dygpt.vue?vue&type=style&index=0&id=0ed1ff0b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed1ff0b",
  null
  
)

export default component.exports